import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import { toggleInstOpened } from "../../actions/actionFunctions";

class InstallButton extends Component {

  static propTypes = {
    questionShown: PropTypes.bool
  };

  render() {
    let fabSettings = this.props.fabricatorSettings;
    return (
      <button className={"materials-button materials-button--install" + ((this.props.questionShown || this.props.questionNoClicked) && (fabSettings.addLaborCustomer || (document.kvConfig.isBackend && fabSettings.addLaborInstaller)) ? " materials-button--install--visible" : "")}
              onClick={() => this.props.toggleInstOpened(!this.props.instOpened)}>
        <span className="materials-button__text"><FormattedMessage id={"installationButton.install"}/></span>
      </button>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    questionNoClicked: store.cartState.questionNoClicked,
    instOpened: store.instState.instOpened,
    fabricatorSettings: store.fabricatorState.settings,
  };
};

export default connect(mapStateToProps, {
  toggleInstOpened
})(InstallButton);
